import { findClosestSegment } from "../../../../utils/locationUtils";

/**
 * 
 * @param {Object[]} data - array of table data
 * @param {function} setValidationErrors - sets validation errors in parent component
 * @param {Object} schema 
 * @param {Object[]} agmOptions dropdown options for AGMs - helps to validate subchain US/DS sites
 * 
 * @returns {boolean} returns true if table data passes validation, false if there are errors
 */
export const validateTableData = (data, setValidationErrors, schema, agmOptions = []) => {
  const validationErrors = [];

  const agmMap = new Map()
  agmOptions.forEach(agm => {
    agmMap.set(agm.value, agm)
  })

  //check data against required items in schema
  //if a required item has not been filled out, add to errors
    //invalid if 
      // -field null/undefined
      // -string values are empty
      // -subchains: US/DS sites don't match any allowed options in agmOptions (checked via map for faster look-up)
  data.forEach((row, rowIndex) => {

    Object.keys(schema).forEach((key) => {
      if (
        schema[key]?.required &&
        (
          row[key] === null || row[key] === undefined ||
          (typeof row[key] === "string" && row[key].length === 0) ||
          (agmMap.size > 0 && (key === 'US_Site' || key === 'DS_Site') && !checkUSDSSiteFound(agmMap, row[key]))
        )

      ) {
        validationErrors.push({ row: rowIndex, column: key });
      }
    });

  });

  if(Object.keys(schema).includes('OrderNum')){
    checkDuplicateOrderNums(data, validationErrors);
  }
  

  //if errors were found, update validationErrors state and return false
  if (validationErrors.length > 0) {
    setValidationErrors(validationErrors)

    return false
  }

  return true

};

const checkDuplicateOrderNums = (data, validationErrors) => {
  const seen = new Map();
  
  data.forEach((item, index) => {
    const orderNum = Number(item.OrderNum);
    if (seen.has(orderNum)) {
      const originalIndex = seen.get(orderNum);

      // Push error for the original if not already added
      if (!validationErrors.some(err => err.row === originalIndex && err.column === 'OrderNum')) {
        validationErrors.push({ row: originalIndex, column: 'OrderNum' });
      }

      // Push error for the duplicate
      validationErrors.push({ row: index, column: 'OrderNum' });
    } else {
      seen.set(orderNum, index);
    }
  });
};

const checkUSDSSiteFound = (agmMap, site) => {
  if(agmMap.has(site)) return true

  return false
}

/**
 * 
 * @param {float} scLat
 * @param {float} scLng
 * @param {Object[]} agmData
 * 
 * @returns {Object} returns the closest segement {upstream, downstream} to be compared in validation 
 * @description This validation function will check what segment the sc lat and lng are in and
 *              make sure the us and ds sites are correct
 *              ->FUTURE give more details on where it thinks it should be
 *              ->distance it is out
 */
export const scValidateUsAndDs = (scLat, scLng, agmData) => {
  //mutuate the array to fit the findClosestSegment function
  for(let agm of agmData) {
    //Real takes priority over Estimated
    agm.lat = agm.Real_Lat || agm.Est_Lat;
    agm.lng = agm.Real_Lng || agm.Est_Lng;
  }
  let data = findClosestSegment({lat: scLat, lng: scLng}, agmData);

  return data;
}